import { InfoItem } from 'components/molecules/InfoItem/InfoItem';
import { CompanyPageCompanyFragment } from 'generated/graphql';
import { useState } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import { CANDIDATE_PORTAL_ENABLED_LABEL } from './CandidatePortalSection.constants';
import CandidatePortalSectionForm from './CandidatePortalSectionForm';
import styles from './CandidatePortalSection.module.scss';

type CandidatePortalSectionProps = {
  company: CompanyPageCompanyFragment;
};

// Company-level entitlement for the whitelabeled candidate portal
// (`Company.isWhitelabelingEnabled`). Branding config and the per-role portal
// toggle in the company app are only available while this is on.
const CandidatePortalSection = ({ company }: CandidatePortalSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  return isEditing ? (
    <CandidatePortalSectionForm
      company={company}
      onCancelClick={handleCancelClick}
      onSave={handleSave}
    />
  ) : (
    <CandidatePortalSectionView
      company={company}
      onEditClick={handleEditClick}
    />
  );
};

const CandidatePortalSectionView = ({
  company,
  onEditClick,
}: {
  company: CompanyPageCompanyFragment;
  onEditClick: () => void;
}) => (
  <div className={styles.viewContainer}>
    <div className={styles.header}>
      <h3 className={styles.title}>Candidate Portal</h3>
      <Button variant="secondary" size="medium" onClick={onEditClick}>
        Edit
      </Button>
    </div>
    <div className={styles.content}>
      <InfoItem
        label={CANDIDATE_PORTAL_ENABLED_LABEL}
        value={company.isWhitelabelingEnabled ? 'Enabled' : 'Disabled'}
      />
    </div>
  </div>
);

export default CandidatePortalSection;
